import { option } from "fp-ts";
import { saveAs } from "file-saver";
import {
  convertToBlob,
  useAuthenticationContext,
} from "@dbn/omnichannel-design-system-g4p";
import { getLatestToken } from "../APICall";
import { downloadWithDeepLink } from "./useSBDeepLink";
import { DocumentContentOutput } from "./documentAPI";
import { useIsSBChannel } from "../useChannel";
import { useCompareAppVersions } from "./useCompareAppVersions";

export function useDownloadDocumentToDevice() {
  const { authInfo } = useAuthenticationContext();
  const isSBChannel = useIsSBChannel();
  const { isPostDownloadCompatible } = useCompareAppVersions();

  const downloadDesktop = (file: DocumentContentOutput) =>
    saveAs(convertToBlob(file.content, "PDF"), file.filename);

  const downloadMobile = (file: DocumentContentOutput) => {
    return option.isNone(file.downloadUrlPost) || !isPostDownloadCompatible
      ? downloadDesktop(file)
      : downloadWithDeepLink(
          file.downloadUrlPost.value,
          file.mimeType,
          file.filename,
          option.isSome(file.headers) ? file.headers.value : [],
          getLatestToken(authInfo)
        )();
  };

  return (file: DocumentContentOutput) =>
    isSBChannel ? downloadMobile(file) : downloadDesktop(file);
}
